import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-tick\">\r\n    <path d=\"M13.43 18.02l-3.32-3.14L9 15.98l4.43 4.25 8.49-8.12-1.1-1.11z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol